export const historyLogTypes = {
    action: "action",
    revision: "revision",
};
